'use strict';

module.exports = {
    UNAVIALABLE_SERVICE: 'Сервис недоступен. Пожалуйста, попробуйте позже.',
    NEED_ACTIVE: 'Вы вошли на этот сайт с аккаунта {{account}} впервые. Пожалуйста, {{activeLink}}, чтобы завершить создание аккаунта, и вернитесь на эту страницу, чтобы продолжить работу.',
    GOTO_ACTIVE: 'Активировать',
    NOT_ACTIVED: 'Аккаунт пока не был активирован, пожалуйста {{activeLink}}, чтобы подтвердить активацию.',
    COMPLETE_ACTIVE: 'Подтвердить активацию',
    FORBID_ACTIVE: 'Аккаунт не поддерживается AliExpress',
    SIGN_UP_WITH_ANOTHER_ACCOUNT: 'Используйте другой аккаунт для входа',
    ACTIVE_PAGE: 'откройте страницу активации'
};